import React from 'react';

function ArrowDown(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M4.45421 13.0582C4.21031 12.814 3.81458 12.8137 3.57033 13.0576C3.32608 13.3015 3.32581 13.6973 3.56971 13.9415L11.2049 21.5874C11.6442 22.0273 12.357 22.0275 12.7966 21.5879L20.4411 13.9418C20.6851 13.6977 20.6851 13.3019 20.441 13.0579C20.1969 12.8138 19.8012 12.8139 19.5571 13.058L12.6305 19.9861L12.6305 2.60927C12.6305 2.26409 12.3507 1.98427 12.0055 1.98427C11.6603 1.98427 11.3805 2.26409 11.3805 2.60927V19.9942L4.45421 13.0582Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowDown;
